// extracted by mini-css-extract-plugin
export default {"button":"GetPricing_button__MWCdx"};